import { render } from "./AddPaymentMethod.vue?vue&type=template&id=14628ded&ts=true"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=ts"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__